<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M12 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-1.5 8a4 4 0 0 0-4 4 2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 4 4 0 0 0-4-4zm6.8-3.1a5.5 5.5 0 0 0-2.8-6.3 3.5 3.5 0 1 1 2.8 6.3m2.2 7.1h.5a2 2 0 0 0 2-2 4 4 0 0 0-4-4h-1.1l-.5.8a6 6 0 0 1 3 5.2M4 7.5a3.5 3.5 0 0 1 5.4-2.9A5.5 5.5 0 0 0 6.6 11 3.5 3.5 0 0 1 4 7.5M7 12H6a4 4 0 0 0-4 4 2 2 0 0 0 2 2h.5a6 6 0 0 1 3-5.2z"
      clip-rule="evenodd"
    />
  </svg>
</template>
